import { Flex, BodyText, Box } from '@utilitywarehouse/hearth-react';
import { color } from '@utilitywarehouse/hearth-tokens/js';

import InnerContainer from '~/components/Layout/InnerContainer';
import SectionContainer from '~/components/Layout/SectionContainer';

import uwlogoheader from '../assets/uwlogoheaderrebrand.svg';
import './Header.css';

interface HeaderProps {
  partnerName?: string;
}

function Header({ partnerName }: HeaderProps) {
  return (
    <SectionContainer
      as="header"
      backgroundColor={color.purple[700]}
      dataTestId="header"
    >
      <InnerContainer>
        <Flex
          gap="200"
          justifyContent={{
            mobile: 'center',
            tablet: 'between',
          }}
          direction={{
            mobile: 'column',
            tablet: 'row',
          }}
          alignItems="center"
        >
          <Flex direction="row" alignItems="center">
            <img src={uwlogoheader} className="logo" alt="Utility Warehouse" />
          </Flex>
          {partnerName && (
            <Box className="header-partner-name">
              <BodyText color="inverted" size="lg" weight="semibold">
                Save more with{' '}
                <span style={{ display: 'block' }}>{partnerName}</span>
              </BodyText>
            </Box>
          )}
        </Flex>
      </InnerContainer>
    </SectionContainer>
  );
}

export default Header;
